<div class="row justify-content-md-center no-gutters greyBgBody text-center marL10">
    <div class="col-12">
        <div class="row no-gutters">
            <div class="col-12 additionalQuestionSection whiteBg">
                <h5 class="sectionTitleBig">Manage Country/Location Mailbox</h5>
                <div class="col-3 display_inlineBlock">
                    <div class="col-12">
                        <div class="form-group">
                            <select class="form-control custom-select" id="select-" name="" [(ngModel)]="selectedCountry" (change)="getFilteredCountryList(selectedCountry, true)">
                                <option value="Country_Location">Country/Location</option>
                                <option *ngFor="let country of countries" value="{{country?.Name}}">{{country?.Name}}</option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>
                </div>
                <div class="col-12 display_inlineBlock">
                    <div class="manageMailBoxDatGridArea">
                        <app-smart-data-grid [sampleColumns]="sampleColumns" [sampleData]="filteredCountries" [allowCheckbox]="false"
                                             [iseventRegistered]="true" [allowPagination]="true"
                                             [isClientSidePagination]="true" (informParentComponent)="onRowSelect($event)"
                                             (handlePageChangeEvent)="updateListData($event)" [totalRecord]="totalRecords" [pageSize]="50"></app-smart-data-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-update-email-address [countryDetails]="countryDetailsSelected" (updatedEmail)="updateEmail($event)"></app-update-email-address>
</div>
